<template>
  <div class="ele-body">
    <el-card shadow="never">
      <el-form
        :model="where"
        label-width="77px"
        class="ele-form-search"
        @keyup.enter.native="reload"
        @submit.native.prevent>
        <el-row :gutter="15">
          <el-col :lg="6" :md="12">
            <el-form-item label="国家名称">
              <el-select
                v-model="where.country_id"
                clearable
                filterable
                placeholder="请选择"
                class="ele-fluid"
                :loading="countryLoading">
                <el-option
                  v-for="item in countryList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <el-form-item label="银行名称">
              <el-input v-model.trim="where.bank_name" clearable placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <el-form-item label="银行编码">
              <el-input v-model.trim="where.bank_code" clearable placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <div class="ele-form-actions">
              <el-button type="primary" icon="el-icon-search" class="ele-btn-icon" @click="reload">查询</el-button>
              <el-button @click="reset">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>

      <ele-pro-table
        ref="table"
        :where="where"
        :datasource="url"
        :columns="columns"
        :selection.sync="selection"
        height="calc(100vh - 315px)">
        <template slot="toolbar">
          <el-button
            size="small"
            type="primary"
            icon="el-icon-plus"
            class="ele-btn-icon"
            @click="openEdit(null)">
            添加
          </el-button>
          <el-button
            size="small"
            type="danger"
            icon="el-icon-delete"
            class="ele-btn-icon"
            :disabled="!selection.length" @click="removeBatch">
            删除
          </el-button>
        </template>
        <template slot="action" slot-scope="{ row }">
          <el-button
            size="small"
            type="primary"
            class="ele-btn-icon"
            @click="openEdit(row)">编辑
          </el-button>
          <el-popconfirm
            class="ele-action"
            title="确定要删除此银行吗？"
            @confirm="remove(row)">
            <el-button slot="reference" size="small" type="danger" class="ele-btn-icon">删除</el-button>
          </el-popconfirm>
        </template>
      </ele-pro-table>
    </el-card>
    <banks-edit :data="current" :visible.sync="showEdit" @done="reload" />
  </div>
</template>

<script>
import BanksEdit from './banks-edit';

export default {
  name: 'ConfigBanks',
  components: { BanksEdit },
  data() {
    return {
      url: '/ChinaBanks/index',
      columns: [
        {
          columnKey: 'selection',
          type: 'selection',
          width: 45,
          align: 'center',
          fixed: 'left'
        },
        {
          prop: 'id',
          label: '序号',
          width: 70,
          align: 'center'
        },
        {
          prop: 'country_name',
          label: '国家名称',
          minWidth: 100,
          align: 'center',
          showOverflowTooltip: true
        },
        {
          prop: 'bank_name',
          label: '银行名称',
          minWidth: 140,
          align: 'center',
          showOverflowTooltip: true
        },
        {
          prop: 'bank_code',
          label: '银行编码',
          minWidth: 140,
          align: 'center',
          showOverflowTooltip: true
        },
        {
          columnKey: 'action',
          label: '操作',
          width: 160,
          align: 'center',
          resizable: false,
          slot: 'action',
          fixed: 'right'
        }
      ],
      where: {},
      selection: [],
      current: null,
      showEdit: false,
      countryList: [],
      countryLoading: false
    };
  },
  mounted() {
    this.queryCountryList();
  },
  methods: {
    queryCountryList() {
      this.countryLoading = true;
      this.$http.get('/CountryRegion/getCountryRegionList').then((res) => {
        this.countryLoading = false;
        if (res.data.code === 0) {
          this.countryList = res.data.data || [];
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch((e) => {
        this.countryLoading = false;
        this.$message.error(e.message);
      });
    },
    reload() {
      this.$refs.table.reload({ where: this.where });
    },
    reset() {
      this.where = {};
      this.reload();
    },
    openEdit(row) {
      this.current = row;
      this.showEdit = true;
    },
    remove(row) {
      const loading = this.$loading({ lock: true });
      this.$http.post('/ChinaBanks/delete', { id: row.id }).then((res) => {
        loading.close();
        if (res.data.code === 0) {
          this.$message.success(res.data.msg);
          this.reload();
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch((e) => {
        loading.close();
        this.$message.error(e.message);
      });
    },
    removeBatch() {
      if (!this.selection.length) {
        this.$message.error('请选择');
        return;
      }
      this.$confirm('确定要删除选中的银行吗？', '提示', { type: 'warning' }).then(() => {
        const loading = this.$loading({ lock: true });
        this.$http.post('/ChinaBanks/delete', {
          id: this.selection.map((d) => d.id)
        }).then((res) => {
          loading.close();
          if (res.data.code === 0) {
            this.$message.success(res.data.msg);
            this.reload();
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch((e) => {
          loading.close();
          this.$message.error(e.message);
        });
      }).catch(() => {});
    }
  }
};
</script>
